import { Component, OnInit } from '@angular/core';
import { ConexionesService } from '../../services/conexiones.service'
import { environment } from "../../../environments/environment";
import { ActivatedRouteSnapshot, NavigationEnd, Router } from '@angular/router';

@Component({
  selector: 'app-propuestas',
  templateUrl: './propuestas.component.html',
  styleUrls: ['./propuestas.component.css']
})
export class PropuestasComponent implements OnInit {

  tema: any
  subtema: any
  nombre:any;
  fechanac:any
  telefono: any;
  email: any;
  nivel:any
  oficio:any
  labora:any
  empresa:any
  labora2:any
  dependencia:any
  institucion:any
  miembroosc:any
  nombreosc:any
  estudia:any
  tema2:any

  
  reglamento:any;
  comentarios:any;
  
  displayTitulo:any;
  twofiles= false;
  cambia=false;
  siteKey = environment.KEY_CAPTCHA;
  captcha = false;
  norobot= false;

  habil=false
  op1=false
  op2=false
  testData:any
  correcto=false
  arraySubtema=[]
  captura=false
  subtema2:any
  hora="";
  constructor(private db: ConexionesService, private router: Router) {



   }

  ngOnInit(): void {
    this.op1 = false
    this.op2 = false
  }
  opcion1(){
    this.op1=true
    this.op2 = false
    this.habil = true
  }
  opcion2() {
    this.op1 = false
    this.op2 = true
    this.habil = false
  }
  upload(event){
    const target = event.target as HTMLInputElement;
    const files = target.files as FileList;
    console.log(files);

    let testData: FormData = new FormData();
    testData.append('file', files[0], files[0].name);

    this.testData=testData
    console.log(this.testData)
    this.habil=true
    
  }
  enviar(){

  
      this.db.enviaCorreo(this.tema, this.subtema, this.nombre, this.fechanac, this.telefono, this.email, this.nivel, this.oficio, this.labora, this.empresa, this.labora2, this.dependencia, this.institucion, this.miembroosc, this.nombreosc, this.estudia, this.testData).then((resp) => {
        console.log(resp)
        if (resp == 1) {
          alert("Su información ha sido enviada correctamente");
          this.correcto=true
          //this.router.navigate(['/inicio']);
        }
      })
     
  
   
    
    this.captcha = false;
    this.norobot= false;
  }
  opcionSelect(){
    this.cambia= true;
    this.twofiles= false;

    console.log(this.reglamento)


    if(this.reglamento=="Anteproyecto de Reglamento para Plazas, Parques, Jardines y Monumentos de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }
    if(this.reglamento=="Reglamento de Mejora Regulatoria de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }

    if(this.reglamento=="Reglamento de Planeacion de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }
    if(this.reglamento=="Reglamento de Proteccion Civil y Bomberos del Municipio de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }
    if(this.reglamento=="Reglamento de Transito y Vialidad para el Municipio de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }
    if(this.reglamento=="Reglamento del Rastro Municipal de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }
    if(this.reglamento=="Reglamento Interno del Consejo Municipal de Mejora Regulatoria de Nuevo Laredo, Tamaulipas"){
      this.twofiles= true;
    }
    if (this.reglamento == "Reglamento Interior del Republicano Ayuntamiento de Nuevo Laredo, Tamaulipas") {
      this.twofiles = true;
    }

    


      this.displayTitulo= this.reglamento;
  }
  opcionSelectTema2(tema,subtema){
    this.tema = tema
    this.tema2 = tema.toUpperCase()
    this.captura=true
   
    this.subtema=subtema
    this.subtema2 = subtema.toUpperCase()

    console.log(this.tema)
    console.log(this.subtema)

   
    if (this.tema == "Desarrollo humano") {
    
      this.arraySubtema = [{
        item: "Educación"
      },
      {
        item: "Arte y cultura"
      },
      {
        item: "Cultura física y práctica del deporte"
      }
      ]
      this.hora='09:00';

    }
    if (this.tema == "Paz y convivencia ciudadana") {
      console.log("entra")
      this.arraySubtema = [{
        item: "Protección civil"
      },
      {
        item: "Seguridad vial"
      },
      {
        item: "Paz y orden"
      },
      {
        item: "Cuidado y respeto animal"
      }
      ]
      this.hora = '09:00';

    }
   
                      
    if (this.tema == "Bienestar y familia") {
      this.arraySubtema = [{
        item: "Derechos de las mujeres"
      },
      {
        item: "Derechos de las niñas, niños y adolescentes"
      },
      {
        item: "Derechos de las personas con discapacidad"
      },
      {
        item: "Derechos de los adultos mayores"
      },
      {
        item: "Derechos de los jóvenes"
      },
      {
        item: "Derecho a la salud oportuna y de calidad"
      },
      {
        item: "Derecho a la salud emocional y mental"
      },
      {
        item: "Derecho a la alimentación saludable y nutritiva"
      },
      {
        item: "Inclusión y respeto a la población LGBTIQ+"
      },
      {
        item: "Derechos de los migrantes"
      }
      ]
      this.hora = '09:00';
    }
    if (this.tema == "Desarrollo Económico con prosperidad para todos") {
      this.arraySubtema = [{
        item: "Industria"
      },
      {
        item: "Impulso al fomento y comercio local"
      },
      {
        item: "Empresas de servicio y comercio exterior"
      },
      {
        item: "Turismo"
      },
      {
        item: "Desarrollo rural"
      },
      {
        item: "Competitividad"

      }
      ]
      this.hora = '13:00';

    }
    if (this.tema == "Gobierno eficiente y de resultados") {
      this.arraySubtema = [{
        item: "Gobierno humanista"
      },
      {
        item: "Desarrollo administrativo y tecnológico"
      },
      {
        item: "Finanzas sanas"
      },
      {
        item: "Transparencia y rendición de cuentas"
      },
        {
          item: "Combate a la corrupción"
        },
      {
        item: "Planeación y evaluación gubernamental"
      },
      {
        item: "Liderazgo binacional"

      }
      ]
      this.hora = '13:00';
    }
    if (this.tema == "Transformación de la ciudad") {
      this.arraySubtema = [{
        item: "Obras públicas para el desarrollo social y económico"
      },
      {
        item: "Movilidad urbana"
      },
      {
        item: "Vivienda digna"
      },
      {
        item: "Servicios Públicos"
      },
      {
        item: "Protección al medio ambiente"
      },
      {
        item: "Conectividad digital"

      },
        {
          item: "Agua potable para toda la ciudadanía"

        },
        
        {
          item: "Planeación Urbana"

        }
      ]
      this.hora = '13:00';
    }

  
    const elementList = document.querySelectorAll('#captura');
    
   
    const element = elementList[0] as HTMLElement;
    console.log(element)
    element?.scrollIntoView({ behavior: 'smooth' });

  }
  opcionSelectTema() {

    if (this.tema == "Desarrollo humano") {
      this.arraySubtema = [{
         item: "Educacion"
         },
        {
          item: "Arte y cultura"
        },
        {
          item: "Cultura física y práctica del deporte"
        }
        ]

      
    }
    if (this.tema == "Paz y convivencia ciudadana") {
      this.arraySubtema = [{
        item: "Protección civil"
      },
      {
        item: "Seguridad vial"
      },
      {
        item: "Paz y orden"
      },
      {
          item: "Cuidado y respeto animal"
      }
      ]


    }
    if (this.tema == "Bienestar y familia") {
      this.arraySubtema = [{
        item: "Derechos de las mujeres"
      },
      {
        item: "Derechos de las niñas, niños y adolescentes"
      },
      {
        item: "Derechos de las personas con discapacidad"
      },
      {
        item: "Derechos de los adultos mayores"
      },
        {
          item: "Derechos de los jóvenes"
        },
        {
          item: "Derecho a la salud oportuna y de calidad"
        },
        {
          item: "Derecho a la salud emocional y mental"
        },
        {
          item: "Derecho a la alimentación saludable y nutritiva"
        },
        {
          item: "Inclusión y respeto a la población LGBTIQ+"
        },
        {
          item: "Derechos de los migrantes"
        }
      ]

    }
    if (this.tema == "Desarrollo Económico con prosperidad para todos") {
      this.arraySubtema = [{
        item: " Industria"
      },
      {
        item: "Impulso al fomento y comercio local"
      },
      {
        item: "Empresas de servicio y comercio exterior"
      },
      {
        item: "Turismo"
      },
      {
        item: "Desarrollo rural"
      },
      {
        item: " Competitividad"
      
      }
      ]
      
    }
    if (this.tema == "Gobierno eficiente y de resultados") {
      this.arraySubtema = [{
        item: "Gobierno humanista"
      },
      {
        item: "Desarrollo administrativo y tecnológico"
      },
      {
        item: "Finanzas sanas"
      },
      {
        item: "Transparencia y rendición de cuentas"
      },
      {
        item: "Planeación y evaluación gubernamental"
      },
      {
        item: "Liderazgo binacional"

      }
      ]

    }
    if (this.tema == "Transformación de la ciudad") {
      this.arraySubtema = [{
        item: "Obras públicas para el desarrollo social y económico"
      },
      {
        item: "Movilidad urbana"
      },
      {
        item: "Vivienda digna"
      },
      {
        item: "Servicios Públicos"
      },
      {
        item: "Protección al medio ambiente"
      },
      {
        item: "Conectividad digital"

      }
      ]

    }

  }
  handleSuccess(e) {
    this.captcha = true;
    this.norobot = true;

  }

  handleExpire(e) {
    this.captcha = false;
  }
}
